import { useQuery } from '@tanstack/react-query';
import { GitLabApi } from 'osep-generator-service-client-v1';
import { GITLAB_SUBGROUPS_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useGitLabSubgroups(groupId: string, enabled = true) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [GITLAB_SUBGROUPS_KEY, { groupId: groupId }],
    enabled: enabled,
    queryFn: () =>
      getApiConfig().then((config) =>
        new GitLabApi(config, undefined, axiosInstance)
          .getSubgroups(groupId)
          .then((response) => response.data),
      ),
  });
}

export default useGitLabSubgroups;
